export const hideLoader = () => {
  let loader = document.getElementById('appLoader');
  if (loader !== null) {
    loader.style.opacity = '0';
  }
};

export const showLoader = () => {
  let loader = document.getElementById('appLoader');
  if (loader !== null) {
    loader.style.opacity = '1';
  }
};
